module.exports = __webpack_public_path__ + "static/media/feishu_video.2092c823.png";